// Real Google reviews for Alpha 1 Industrial Services (5.0 ★ on Google).
// Longer reviews are trimmed at sentence boundaries; wording is otherwise
// verbatim from the reviewers (light typo cleanup only).
// Add or edit reviews at /admin under the "Reviews" tab.
const reviews = [
  {
    id: "review-demetre-christou",
    name: "Demetre Christou",
    rating: 5,
    date: "4 months ago",
    text:
      "We hired Alpha1 to unload and place a CNC Machine at the ICICS building at UBC. Not only did they accommodate multiple delays ranging from days to hours, but they did so with a pleasant disposition.",
    visible: true,
    source: "manual",
  },
  {
    id: "review-sina-hosseini",
    name: "Sina Hosseini",
    rating: 5,
    date: "a year ago",
    text:
      "I recently hired Alpha 1 Industries to offload my machinery and equipment from shipping containers and move everything into my unit. They did an incredibly professional job from start to finish.",
    visible: true,
    source: "manual",
  },
  {
    id: "review-irene-banez",
    name: "Irene Bañez",
    rating: 5,
    date: "a year ago",
    text:
      "Alpha 1 Industrial Services are absolutely amazing. They came and moved all of my companies machines from 2 locations to one. Saved us so much time in recommissioning our machines. Extremely knowledgeable, experienced, fast and friendly.",
    visible: true,
    source: "manual",
  },
  {
    id: "review-david-mitten",
    name: "David Mitten",
    rating: 5,
    date: "11 months ago",
    text:
      "Alpha 1 did a fantastic job moving my Milling machine and Lathe. They brought a crane truck and 4 guys and made moving large machines look easy!",
    visible: true,
    source: "manual",
  },
  {
    id: "review-mark-robertson",
    name: "Mark Robertson",
    rating: 5,
    date: "a year ago",
    text:
      "Used Alpha 1 today to move a machine, nothing but good things to say about Zunaid and his sons! Prompt, professional, knowledgeable and great communication. I will definitely use Alpha 1 again when the time comes and would recommend to anyone.",
    visible: true,
    source: "manual",
  },
  {
    id: "review-derek-gulkison",
    name: "Derek Gulkison",
    rating: 5,
    date: "a year ago",
    text:
      "We had a 900 pound unit that needed moving quickly from Vancouver to North Burnaby. Zunaid was able to take on the job for a great price.",
    visible: true,
    source: "manual",
  },
  {
    id: "review-mike-vangool",
    name: "Mike VanGool",
    rating: 5,
    date: "a month ago",
    text: "Highly recommend, these guys are awesome at what they do.",
    visible: true,
    source: "manual",
  },
  {
    id: "review-rob-guthrie",
    name: "Rob Guthrie",
    rating: 5,
    date: "3 months ago",
    text: "Thank you guys for your excellent work!",
    visible: true,
    source: "manual",
  },
];

export default reviews;
